import { ComponentsBoxCondition } from "@omni/types/components/cart/shared/enums/boxCondition.enum";
import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useCheckoutCustomerContext } from "../checkoutCustomer.context";
import { BoxConditionsFormValues } from "./boxConditions.schema";
import { BoxAgeConditionComponent } from "./components/ageCondition.component";
import { BoxContestConditionComponent } from "./components/contestCondition.component";
import { BoxPartnerConditionComponent } from "./components/partnerCondition.component";

const BoxConditionsComponent = <T extends BoxConditionsFormValues>() => {
    const { t } = useGranite();
    const { activeBoxConditions } = useCheckoutCustomerContext();

    if (activeBoxConditions.length === 0) {
        return null;
    }

    return (
        <section className={cn("tw:mb-6")}>
            <h2>{t("checkout.customerDetails.boxConditions.title")}</h2>
            <hr />
            {activeBoxConditions.map((condition, index) => {
                return (
                    <div key={index}>
                        <Row>
                            <Col>
                                {condition.name ===
                                    ComponentsBoxCondition.ContestConditions && (
                                    <BoxContestConditionComponent />
                                )}
                                {condition.name ===
                                    ComponentsBoxCondition.AgeCondition && (
                                    <BoxAgeConditionComponent<T>
                                        required={condition.required}
                                        label={t(
                                            `checkout.customerDetails.ageCondition.label`
                                        )}
                                    />
                                )}
                                {condition.name ===
                                    ComponentsBoxCondition.PartnerConditions && (
                                    <BoxPartnerConditionComponent<T>
                                        required={condition.required}
                                        label={t(
                                            `checkout.customerDetails.partnerCondition.label`
                                        )}
                                    />
                                )}
                            </Col>
                        </Row>
                    </div>
                );
            })}
        </section>
    );
};

export { BoxConditionsComponent };
